import {reduxStore} from '../../store';
import {hideAlert, showAlert as showAlertAction} from '../../store/common/alert.slice';
import {Platform} from 'react-native';

let pauseCopyProtection;
const pendingAlerts = [];

if (Platform.OS === 'web' ) {
    pauseCopyProtection = function (e) {
        e.stopImmediatePropagation();
    };
}

const isAlertVisible = () => Boolean(reduxStore.getState().alert?.alertVisible);

const showAlert = ({title, message, alertButtons}) => {
    if (Platform.OS === 'web' ) {
        document.addEventListener('copy', pauseCopyProtection, {capture: true});
    }
    reduxStore.dispatch(showAlertAction({title, message, alertButtons}));
};

const showNextAlert = () => {
    if (isAlertVisible()) {
        return false;
    }
    const nextAlert = pendingAlerts.shift();
    if (nextAlert) {
        showAlert(nextAlert);
        return true;
    }
    return false;
};

const AlertModal = {

    alert: (title, message, alertButtons) => {
        const alert = {title, message, alertButtons};
        if (isAlertVisible()) {
            pendingAlerts.push(alert);
            return;
        }
        showAlert(alert);
    },
    hide: ({showNext = true} = {}) => {
        reduxStore.dispatch(hideAlert());

        if (showNext) {
            const nextAlertShown = showNextAlert();
            if (!nextAlertShown && Platform.OS === 'web') {
                document.removeEventListener('copy', pauseCopyProtection, {capture: true});
            }
        } else if (Platform.OS === 'web') {
            document.removeEventListener('copy', pauseCopyProtection, {capture: true});
        }
    },
    showNext: showNextAlert,
};

Object.defineProperty(AlertModal, 'isShown', {
    get: isAlertVisible,
});

export default AlertModal;
